<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{}">
      <BaseButton
        v-if="create"
        @click="openModal"
        :text="localStorage.translations.pages.common['buttons']['dobavit']"
        reverse
        default_icon="button-add"
        :icon_only="$vuetify.breakpoint.width < 500"
      />
      <EditBtn v-else :openModal="openModal" />
    </template>
    <transition :duration="150">
      <div class="edit">
        <CloseModalBtn :closeModal="closeModal" />
        <h5>
          {{
            create
              ? localStorage.translations.pages.sales_project['planned_resources-time_period'][
                  'dobavlenie-vremennogo-perioda'
                ]
              : localStorage.translations.pages.sales_project['planned_resources-time_period'][
                  'redaktirovanie-vremennogo-perioda'
                ]
          }}
        </h5>
        <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="onCreateOrUpdatePeriod">
          <div class="item">
            <label class="inputBox_title createAndSelect primary--text fw500">{{
              localStorage.translations.pages.sales_project['planned_resources-time_period-labels'][
                'data-nachala'
              ]
            }}</label>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  hide-details="auto"
                  v-model="dateStartFormatted"
                  outlined
                  v-bind="attrs"
                  readonly
                  prepend-inner-icon="today"
                  :placeholder="
                    localStorage.translations.pages.sales_project[
                      'planned_resources-time_period-inputs'
                    ]['ne-vybrano']
                  "
                  v-on="on"
                  :rules="[inputRules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                :locale="$cookies.get('languageSelect').key"
                v-model="start_date"
                no-title
                @input="menu1 = false"
                :min="workClientProjectShow.start_date"
                :max="workClientProjectShow.end_date"
                show-week
                first-day-of-week="1"
                @change="onEmloyeeList"
              ></v-date-picker>
            </v-menu>
          </div>
          <div class="item">
            <label class="inputBox_title createAndSelect primary--text fw500">{{
              localStorage.translations.pages.sales_project['planned_resources-time_period-labels'][
                'data-kontsa'
              ]
            }}</label>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  hide-details="auto"
                  v-model="dateEndFormatted"
                  outlined
                  :disabled="!start_date"
                  v-bind="attrs"
                  readonly
                  prepend-inner-icon="today"
                  @blur="end_date = parseDate(dateEndFormatted)"
                  :placeholder="
                    localStorage.translations.pages.sales_project[
                      'planned_resources-time_period-inputs'
                    ]['ne-vybrano']
                  "
                  v-on="on"
                  :rules="[inputRules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                :locale="$cookies.get('languageSelect').key"
                v-model="end_date"
                no-title
                @input="menu2 = false"
                :min="start_date"
                :max="workClientProjectShow.end_date"
                show-week
                first-day-of-week="1"
                @change="onEmloyeeList"
              ></v-date-picker>
            </v-menu>
          </div>
          <div class="item">
            <label class="inputBox_title createAndSelect primary--text fw500">{{
              localStorage.translations.pages.sales_project['planned_resources-time_period-labels'][
                'podrazdelenie'
              ]
            }}</label>
            <v-tooltip
              :disabled="!!end_date && !!employeesPersonAndGroup.length"
              bottom
              color="#2C2C2C"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <TreeselectCustom
                    name="xyz"
                    :rules="[inputRules.required]"
                    v-model="employees"
                    :items="employeesPersonAndGroup"
                    :disabled="!employeesPersonAndGroup.length"
                  />
                </div>
              </template>
              <span>{{
                !end_date
                  ? localStorage.translations.pages.sales_project[
                      'planned_resources-time_period-tooltips'
                    ]['vyberite-datu-kontsa']
                  : localStorage.translations.pages.sales_project[
                      'planned_resources-time_period-tooltips'
                    ]['v-vybrannomu-vremennomu-periodu-otsutstvuyut-svobodnye-sotrudniki']
              }}</span>
            </v-tooltip>
          </div>
          <div>
            <div class="container_btn">
              <BaseButton
                type="submit"
                :text="localStorage.translations.pages.common['buttons']['sohranit']"
                default_icon="button-save"
              />
            </div>
          </div>
        </v-form>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import CloseModalBtn from 'components/CloseModalBtn'

import TreeselectCustom from 'components/TreeselectCustom'
import EditBtn from 'components/EditBtn'

export default {
  name: 'ProjectPlannedResourcesWorkTypePeriodModal',
  components: {
    CloseModalBtn,
    TreeselectCustom,
    EditBtn,
  },
  props: [
    'projectId',
    'create',
    'page',
    'limit',
    'minimalize',
    'reverse',
    'projectWorkTypeId',
    'workTypeId',
    'workTypePeriodId',
  ],
  data() {
    return {
      dialog: false,
      valid: true,
      menu1: false,
      menu2: false,
      menu3: false,
      start_date: null,
      end_date: null,
      employees: [],
      employeesReady: null,
      test: null,
      dateStartFormatted: null,
      dateEndFormatted: null,
      subdivisionList: [],
      employeesPersonAndGroup: [],
      employeeslistGroupId: [],
    }
  },
  watch: {
    dialog() {
      if (this.dialog) {
        if (!this.create) {
          this.onWorkClientProjectsWorkTypePeriodShow(this.workTypePeriodId).then(() =>
            this.onEmloyeeList(),
          )
        }
      }
    },
    start_date(val) {
      this.dateStartFormatted = this.formatDate(this.start_date)
      this.checkDate()
    },
    end_date(val) {
      this.dateEndFormatted = this.formatDate(this.end_date)
      this.checkDate()
    },
    workClientProjectsWorkTypePeriodShow() {
      this.start_date = this.workClientProjectsWorkTypePeriodShow.start_date
      this.end_date = this.workClientProjectsWorkTypePeriodShow.end_date
      this.employeesReady = this.workClientProjectsWorkTypePeriodShow.employees
    },
  },
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    ...mapGetters('workClientProjectsResponsibleEmployees', [
      'workClientProjectsResponsibleEmployeesShow',
    ]),
    ...mapGetters('workClientProjectsWorkTypePeriod', ['workClientProjectsWorkTypePeriodShow']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
    computedDateFormatted() {
      return this.formatDate(this.start_date)
      return this.formatDate(this.end_date)
    },
    pageSalesProjectShow() {
      return this.$route.name === 'SalesProjectShow'
    },
  },
  methods: {
    openModal() {
      this.dialog = true
      if (this.create) {
        this.start_date = null
        this.end_date = null
        this.employees = []
        this.valid = true
      }
    },
    closeModal() {
      this.dialog = false
      this.start_date = null
      this.end_date = null
      this.employees = []
    },
    ...mapActions('employee', ['onEmployeeListGroupsAndWorkTypes']),
    ...mapActions('workClientProjectsWorkTypePeriod', [
      'onWorkClientProjectsWorkTypePeriodCreate',
      'onWorkClientProjectsWorkTypePeriodUpdate',
      'onWorkClientProjectsWorkTypePeriodShow',
      'onWorkClientProjectsWorkTypePeriodAll_project',
    ]),
    validate() {
      this.$refs.form.validate()
    },
    checkDate() {
      if (this.start_date > this.end_date) {
        this.end_date = null
        this.employees = null
        this.subdivisionList = []
      }
    },
    async onEmloyeeList() {
      if (this.start_date && this.end_date) {
        let urlParams =
          '?limit=1000&page=1&filter[]=work_type_id:' +
          this.workTypeId +
          '&additional_data[start]=' +
          this.start_date +
          '&additional_data[end]=' +
          this.end_date +
          '&additional_data[project_id]=' +
          this.$route.params.id +
          '&additional_data[work_type_id]=' +
          this.workTypeId +
          '&language_id=' +
          1
        let data = {
          limit: 0,
          page: 1,
        }

        data.filters =
          '&filter[]=work_type_id:' +
          this.workTypeId +
          '&additional_data[start]=' +
          this.start_date +
          '&additional_data[end]=' +
          this.end_date +
          '&additional_data[project_id]=' +
          this.$route.params.id +
          '&additional_data[work_type_id]=' +
          this.workTypeId +
          '&language_id=' +
          1
        this.onEmployeeListGroupsAndWorkTypes(data).then((resp) => {
          let result = []
          let employeeslistNew = resp.data.data
          if (!this.create && this.workClientProjectsWorkTypePeriodShow.employees) {
            var employeeslist = [
              ...this.workClientProjectsWorkTypePeriodShow.employees,
              ...employeeslistNew,
            ]
          } else {
            var employeeslist = employeeslistNew
          }
          for (let i = 0; i < employeeslist.length; ++i) {
            if (employeeslist[i].group) {
              const checkGroup = (obj) => obj.id_group === '00' + employeeslist[i].group.id
              if (result.findIndex(checkGroup) === -1) {
                let groupObj = {}
                groupObj['id'] =
                  // '00' + employeeslist[i].group.id
                  Math.random()
                groupObj['id_group'] = '00' + employeeslist[i].group.id
                groupObj['label'] = employeeslist[i].group.name

                let employeeGroupObj = {}
                employeeGroupObj['id'] = employeeslist[i].id
                employeeGroupObj['label'] =
                  employeeslist[i].user.first_name + ' ' + employeeslist[i].user.last_name
                groupObj['children'] = [employeeGroupObj]
                result.push(groupObj)
              } else {
                let objGroupReady = result[result.findIndex(checkGroup)]
                let employeeGroupObj = {}
                employeeGroupObj['id'] = employeeslist[i].id
                employeeGroupObj['label'] =
                  employeeslist[i].user.first_name + ' ' + employeeslist[i].user.last_name
                objGroupReady.children.push(employeeGroupObj)
              }
            } else {
              let employeeObj = {}
              employeeObj['id'] = employeeslist[i].id
              employeeObj['label'] =
                employeeslist[i].user.first_name + ' ' + employeeslist[i].user.last_name
              result.push(employeeObj)
            }
          }
          if (!this.create) {
            this.employees = this.workClientProjectsWorkTypePeriodShow.employees.map((i) => i.id)
          }

          return (this.employeesPersonAndGroup = result)
        })
      }
    },
    async onCreateOrUpdatePeriod() {
      await this.validate()
      if (this.valid) {
        // if (!this.employees) {
        //     this.$store.dispatch(
        //         'popup/onMessage',
        //         {
        //             message: this.localStorage.translations.pages.common.notifications.fill_in_required_fields,
        //             IsError: true,
        //         },
        //         { root: true }
        //     )
        //     return
        // }
        let data = {
          id: this.workClientProjectsWorkTypePeriodShow
            ? this.workClientProjectsWorkTypePeriodShow.id
            : null,
          project_work_type_id: this.projectWorkTypeId,
          start_date: this.start_date,
          end_date: this.end_date,
          employees: this.employees,
        }
        if (this.create) {
          return new Promise((resolve, reject) => {
            this.onWorkClientProjectsWorkTypePeriodCreate(data)
              .then((resp) => {
                resolve(resp)
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common['notifications'][
                        'uspeshno-dobavlen'
                      ],
                    IsError: false,
                  },
                  { root: true },
                )
                this.onWorkClientProjectsWorkTypePeriodAll_project(this.$route.params.id)
                this.closeModal()
              })
              .catch((err) => {
                if (err.response.data) {
                  this.$store.dispatch(
                    'popup/onMessage',
                    {
                      message:
                        this.localStorage.translations.pages.common['notifications']['oshibka'],
                      IsError: true,
                    },
                    { root: true },
                  )
                }
              })
          })
        } else {
          return new Promise((resolve, reject) => {
            this.onWorkClientProjectsWorkTypePeriodUpdate(data)
              .then((resp) => {
                resolve(resp)
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common['notifications'][
                        'izmeneniya-uspeshno-sohraneny'
                      ],
                    IsError: false,
                  },
                  { root: true },
                )
                this.onWorkClientProjectsWorkTypePeriodAll_project(this.$route.params.id)
                this.closeModal()
              })
              .catch((err) => {
                if (err.response.data) {
                  this.$store.dispatch(
                    'popup/onMessage',
                    {
                      message:
                        this.localStorage.translations.pages.common['notifications']['oshibka'],
                      IsError: true,
                    },
                    { root: true },
                  )
                }
              })
          })
        }
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
}
</script>

<style lang="scss" scoped>
.edit {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 60px;
  position: relative;
  .close {
    padding: 16px;
  }

  h5 {
    text-align: center;
    margin-bottom: 50px;
  }
  form {
    text-align: left;
    display: grid;
    grid-column-gap: 30px;
    grid-row-gap: 10px;
    label {
      font-weight: normal;
      font-size: 14px;
      line-height: 26px;
      color: #52525f;
    }

    .v-text-field {
      padding-top: 0px;
      margin-top: 0px;
      fieldset {
        border: 1px solid #b4b4b4;
        border-radius: 4px;
      }
      .theme--light.v-icon {
        color: #b4b4b4;
      }
    }
    .container_btn {
      margin-top: 30px;
      display: grid;
      justify-content: center;
    }
    .v-input--selection-controls {
      margin-top: 0;
    }
  }
}
</style>
